export var SectionId;
(function (SectionId) {
    SectionId[SectionId["Articles"] = 0] = "Articles";
    SectionId[SectionId["HelpCenter"] = 1] = "HelpCenter";
    SectionId[SectionId["Resources"] = 2] = "Resources";
    SectionId[SectionId["HirePartner"] = 3] = "HirePartner";
    SectionId[SectionId["ContactUs"] = 4] = "ContactUs";
    SectionId[SectionId["StatusPage"] = 5] = "StatusPage";
    SectionId[SectionId["ChatWithUs"] = 6] = "ChatWithUs";
    SectionId[SectionId["UserContacts"] = 7] = "UserContacts";
    SectionId[SectionId["ShareFeedback"] = 8] = "ShareFeedback";
    SectionId[SectionId["RequestSuccessManager"] = 9] = "RequestSuccessManager";
})(SectionId || (SectionId = {}));
export var ResourceId;
(function (ResourceId) {
    ResourceId[ResourceId["WixLearn"] = 0] = "WixLearn";
    ResourceId[ResourceId["WixBlog"] = 1] = "WixBlog";
    ResourceId[ResourceId["SEOLearningHub"] = 2] = "SEOLearningHub";
    ResourceId[ResourceId["VeloHub"] = 3] = "VeloHub";
    ResourceId[ResourceId["PartnersForum"] = 4] = "PartnersForum";
    ResourceId[ResourceId["CustomerCareTickets"] = 5] = "CustomerCareTickets";
    ResourceId[ResourceId["HireAnotherProfessional"] = 6] = "HireAnotherProfessional";
    ResourceId[ResourceId["CommunityForum"] = 7] = "CommunityForum";
    ResourceId[ResourceId["StudioCommunityForum"] = 8] = "StudioCommunityForum";
    ResourceId[ResourceId["WixDevelopers"] = 9] = "WixDevelopers";
})(ResourceId || (ResourceId = {}));
//# sourceMappingURL=index.js.map